/**
 * «Юниверситет» (28.09): карточка героя — бейдж грейда, класс, опыт, «сейчас: …» и
 * «Игр в роли: N». По ТЗ НЕ показываем: ставку «450 ₽ за игру» («под бейджем только
 * класс»), полоски «Модули / Игры 7/20 / Акцепты» и «До грейда III…» — правила грейдов
 * владелец ещё обсуждает. Полоска здесь — только уровень опыта (xp % level_xp).
 */
import { gradeRoman, type UniPack } from "@ub/shared/uni";
import type { UniStats } from "./useUniStats";
import css from "./uni.module.css";

interface HeroProps {
  pack: UniPack;
  stats: UniStats;
  badgeUrl: string | undefined;
  cls: string;
  xp: number;
  /** «сейчас: …»; null — вся карта пройдена */
  curName: string | null;
  onClass: (id: string) => void;
}

export function Hero({ pack, stats, badgeUrl, cls, xp, curName, onClass }: HeroProps) {
  const roman = stats.grade ? gradeRoman(stats.grade) : null;
  const clsTitle = pack.classes.find((c) => c.id === cls)?.title ?? "";
  const lvl = pack.level_xp > 0 ? xp % pack.level_xp : xp;
  const pct = pack.level_xp > 0 ? Math.min(100, (lvl / pack.level_xp) * 100) : 0;
  const gradeText = stats.grade === undefined ? "Грейд…" : stats.grade === null ? "Грейд не загрузился" : roman ? `Грейд ${roman}` : "Грейд не присвоен";

  return (
    <section className={css.card} aria-label="Персонаж" data-fb="hero" data-fb-name="Персонаж">
      <div className={`${css.hero} ${roman ? "" : css.heroBare}`}>
        {roman ? (
          badgeUrl
            ? <img className={css.badge} src={badgeUrl} alt={`Бейдж грейда ${roman}`} width={96} height={96} />
            : <div className={css.badge} aria-hidden="true" />
        ) : null}
        <div className={css.heroMain}>
          <div className={`${css.lvl} ${roman ? "" : css.lvlNone}`}>
            {gradeText}
            {clsTitle ? <small>{clsTitle}</small> : null}
          </div>
          <div className={css.cls} role="group" aria-label="Класс" data-fb-part="класс">
            {pack.classes.map((c) => (
              <button
                key={c.id}
                type="button"
                className={c.id === cls ? css.clsOn : ""}
                aria-pressed={c.id === cls}
                onClick={() => { if (c.id !== cls) onClass(c.id); }}
              >
                {c.title}
              </button>
            ))}
          </div>
          <div
            className={css.xp}
            role="progressbar"
            aria-label="Опыт уровня"
            aria-valuemin={0}
            aria-valuemax={pack.level_xp}
            aria-valuenow={lvl}
          >
            <i style={{ width: `${pct}%` }} />
          </div>
          <div className={css.xpt}>
            <span>{lvl} / {pack.level_xp} XP</span>
            <span>{curName ? `сейчас: ${curName}` : "карта пройдена"}</span>
          </div>
        </div>
      </div>
      <div className={css.played} data-fb-part="игр в роли">
        Игр в роли: <b>{stats.played === undefined ? "…" : stats.played === null ? "—" : stats.played}</b>
      </div>
    </section>
  );
}
